import { buildApiUrl, ADMIN_ENDPOINTS } from '@/project/configs/api.js'

export default {
  url(payload) {
    return buildApiUrl(ADMIN_ENDPOINTS.REWARD_LEVEL_DELETE.replace(':id', payload.id))
  },

  method() {
    return 'DELETE'
  },

  format() {
    return {}
  },

  parse(raw = {}) {
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        success: false,
        message: raw?.message || 'Erreur lors de la suppression du niveau',
      }
    }
    return {
      statusCode: 200,
      success: true,
      message: 'Niveau supprimé avec succès',
      data: raw?.data,
    }
  },
}
